import Index from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sender-aliases'),
      name: 'sender_aliases_index',
      component: Index,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};